import { useState } from "react"
import { Button, Modal, useOverlayState } from "@heroui/react"
import { cn } from "@heroui/react"
import { countryCodes, type CountryCode } from "@/data/country-codes"

interface CountryCodeSelectProps {
    countries?: CountryCode[]
    value?: string
    onChange?: (code: string) => void
    disabled?: boolean
}

export function CountryCodeSelect({
    countries = countryCodes,
    value = "86",
    onChange,
    disabled = false,
}: CountryCodeSelectProps) {
    const [selectedCountry, setSelectedCountry] = useState<CountryCode>(
        countries.find((c) => c.code === value) || countries[0]
    )
    const countryModal = useOverlayState()

    const handleCountrySelect = (country: CountryCode) => {
        setSelectedCountry(country)
        onChange?.(country.code)
        countryModal.close()
    }

    return (
        <>
            <Button
                variant="ghost"
                size="sm"
                isDisabled={disabled}
                onPress={countryModal.open}
            >
                +{selectedCountry.code}
            </Button>
            <Modal.Backdrop isOpen={countryModal.isOpen} onOpenChange={countryModal.setOpen}>
                <Modal.Container size="md" scroll="inside">
                    <Modal.Dialog>
                        {() => (
                            <>
                                <Modal.Header>
                                    <Modal.Heading>选择国家/地区</Modal.Heading>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="flex flex-col gap-1">
                                        {countries.map((country) => (
                                            <Button
                                                key={`${country.countryCode}-${country.code}`}
                                                variant="ghost"
                                                className={cn(
                                                    "justify-start",
                                                    selectedCountry.countryCode === country.countryCode && "bg-accent"
                                                )}
                                                onPress={() => handleCountrySelect(country)}
                                            >
                                                <span className="mr-2">{country.name_cn}</span>
                                                <span className="text-muted">+{country.code}</span>
                                            </Button>
                                        ))}
                                    </div>
                                </Modal.Body>
                            </>
                        )}
                    </Modal.Dialog>
                </Modal.Container>
            </Modal.Backdrop>
        </>
    )
}
